import React from "react";
import { default as MUICardMedia } from "@mui/material/CardMedia";
import styled from "styled-components";

const StyledMUICardMedia = styled(MUICardMedia)`
  height: 100%;
  width: 100%;
`;

export const CardMedia = (props) => {
  return <StyledMUICardMedia {...props} />;
};
